import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import "./progress-bar.scss";

const ProgressBar = ({ step }: { step: number }) => {
    const { t } = useTranslation();
    const [steps, setSteps] = useState([{
        id: 1,
        name: t("bankDetails"),
        active: true
    }, {
        id: 2,
        name: t("enterOTPLabel"),
        active: false
    }, {
        id: 3,
        name: t("verifyDetails"),
        active: false
    }]);

    useEffect(() => {
        setSteps(steps.map(item => ({ ...item, active: item.id <= step })))
    }, [step])

    return <div className="progress-bar">
        {steps.map((item, index) => {
            return <div key={item.id} className="circle-line-cnt">
                {index !== 0 && <div className={`circle-line ${item.active ? "active" : ""}`}>&nbsp;</div>}
                <div className="circle-cnt">
                    <div className={`circle ${item.active ? "active" : ""}`}>{item.id}</div>
                    <div className={`title ${item.active ? "active" : ""}`} title={item.name}>{item.name}</div>
                </div>
            </div>
        })}
    </div>
}

export default ProgressBar;
